module.exports = __webpack_public_path__ + "static/media/icomoon.a78408f9.svg";